import * as types from './types'

export const mutations = {
  [types.GET_ADVISORS] (state, conseillers) {
      state.conseillers = [...conseillers]
  },
	[types.CREATE_ADVISOR] (state, conseiller) {
		state.conseillers.push(conseiller)
	},
	[types.EDIT_ADVISOR] (state, { conseiller }) {
        const {conseillers} = state
        state.conseillers.forEach((el, index) => {
            if (conseiller.id === el.id) {
                conseillers[index] = {...conseiller}
            }
        });
        state.conseillers = [...conseillers]
	},
	[types.ENABLE_ADVISOR] (state, id) {
    let target = state.conseillers.find((conseiller) => {
      return conseiller.id === id;
    })
    target.enabled = true;
	},
	[types.DISABLE_ADVISOR] (state, id) {
    let target = state.conseillers.find((conseiller) => {
      return conseiller.id === id;
    })
    target.enabled = false;
  },
  [types.SET_ADVISOR] (state, advisor) {
    state.advisor = advisor
    state.advisor.office = advisor.office.name
    state.advisor.picture = (advisor.media) ? process.env.ASSETS_ROOT + advisor.media.file : process.env.API_ROOT + '/assets/user.png'
  },
  [types.SET_CLIENTS] (state, clients) {
    state.clients = clients
  },
	[types.ENABLE_ADVISOR_CLIENT] (state, id) {
    let target = state.clients.find((client) => {
      return client.user.id === id;
    })
    target.user.enabled = true;
	},
	[types.DISABLE_ADVISOR_CLIENT] (state, id) {
    let target = state.clients.find((client) => {
      return client.user.id === id;
    })
    target.user.enabled = false;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Conseillers/mutations.js